import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import router from "./routes/router";

import { useToasterStore } from "@/store/useToasterStore.ts";
import CookieConsent from "@/components/CookieConsent";

const queryClient = new QueryClient();

function App() {
  const { position } = useToasterStore();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Toaster
          className={"relative z-[10000]"}
          closeButton={false}
          gap={12}
          position={position}
          richColors={false}
          toastOptions={{
            unstyled: true,
            duration: 4000,
          }}
          visibleToasts={4}
        />
        <RouterProvider router={router} />
        <CookieConsent />
        {/*<ReactQueryDevtools initialIsOpen={false} />*/}
      </QueryClientProvider>
    </>
  );
}

export default App;
